function SecWelcomeContent({img}){
  return(
      <div className="welcome-content">
          <div className="promo-section">
              <div className="integration-link">
                  <span className="integration-icon">
                      <img src={img} width="24" height="24" alt="" />
                  </span>
                  <span className="integration-text">DeFi and AI Solutions</span>
              </div>
          </div>
          <h1>Artificial Intelligence Crypto Revolution</h1>
          <p>
          StonFi AI offers innovative DeFi and AI solutions, driving the next revolution in artificial intelligence and cryptocurrency. Unlocking advanced crypto opportunities through AI-powered strategies.
          </p>
          <div className="dream-btn-group">
              <a href="#" className="btn dream-btn mr-3">Learn More</a>
              <a href="#" className="btn dream-btn">Contact Us</a>
          </div>
      </div>
  )
}

export default SecWelcomeContent